// src/pages/FAQPage.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, Alert, Placeholder } from 'react-bootstrap';
import { fetchFAQsPublicas } from '../redux/faqSlice';
import CanvasRenderer from '../components/faq/CanvasRenderer';
import '../styles/DocumentosPage.css'; // mismos estilos base que Convenios/Documentos
import '../styles/FAQPage.css';        // estilos propios del acordeón FAQ

const LOGO_URL = 'https://api.sinterec.cl/public/images/SINTEREC_logo.jpg';

export default function FAQPage() {
  const dispatch = useDispatch();
  const { publicas, loading, error } = useSelector((state) => state.faq);

  useEffect(() => {
    document.title = 'SINTEREC — Preguntas Frecuentes';
    dispatch(fetchFAQsPublicas());
  }, [dispatch]);

  return (
    <div
      className="documentos-container"
      role="main"
      aria-label="Página de Preguntas Frecuentes"
    >
      {/* Header con logo + título (mismo patrón que Convenios) */}
      <div className="documentos-header" aria-label="Encabezado de preguntas frecuentes">
        <img
          src={LOGO_URL}
          alt="Logo SINTEREC"
          className="logo-sinterec"
          aria-hidden="true"
        />
        <h1 className="documentos-title" aria-level="1">
          Preguntas Frecuentes
        </h1>
      </div>

      {/* Error */}
      {error && (
        <Alert variant="danger" dismissible role="alert" aria-live="assertive">
          <strong>Error:</strong>{' '}
          {typeof error === 'string' ? error : error?.message || 'No se pudo cargar el contenido.'}
        </Alert>
      )}

      {/* Cargando (skeleton igual que Convenios) */}
      {loading ? (
        <Accordion className="documentos-accordion" aria-label="Cargando preguntas frecuentes...">
          {[1, 2, 3].map((index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
              className="documento-item faq-item"
              aria-hidden="true"
            >
              <Accordion.Header className="documento-header">
                <div className="d-flex align-items-center w-100">
                  <i className="bi bi-question-circle-fill faq-icon me-3" aria-hidden="true"></i>
                  <span className="documento-title">
                    <Placeholder as="div" animation="glow">
                      <Placeholder xs={6} />
                    </Placeholder>
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body className="documento-body">
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                  <Placeholder xs={8} />
                </Placeholder>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      ) : (
        <>
          {publicas && publicas.length > 0 ? (
            <Accordion
              className="documentos-accordion faq-accordion"
              role="region"
              aria-label="Lista de preguntas frecuentes"
            >
              {publicas.map((faq, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={faq.id}
                  className="documento-item faq-item"
                  aria-labelledby={`faq-heading-${index}`}
                >
                  <Accordion.Header className="documento-header" id={`faq-heading-${index}`}>
                    <div className="d-flex align-items-center w-100">
                      <i className="bi bi-question-circle-fill faq-icon me-3" aria-hidden="true"></i>
                      <span className="documento-title fw-bold">{faq.titulo}</span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body
                    className="documento-body faq-body"
                    id={`faq-content-${index}`}
                    aria-labelledby={`faq-heading-${index}`}
                  >
                    {faq.descripcion && (
                      <p className="text-muted faq-descripcion">{faq.descripcion}</p>
                    )}
                    <CanvasRenderer canvasData={faq.canvas_data} />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : (
            <Alert variant="info" className="mt-4" role="status" aria-live="polite">
              Aún no hay preguntas frecuentes publicadas. Vuelve pronto.
            </Alert>
          )}
        </>
      )}
    </div>
  );
}